<template>
    <!-- :score="gameOver ? ' ' : $store.getters['quiz/score']" -->
  <GameLayout
    score=" "
    class="d-flex align-center flex-column grey-bg"
    :class="{
      'success lighten-4': gameOver,
      'pattern': isChat,
    }"
    @close="$track('game_leave', 'quiz')"
  >
    <!-- Loading screen -->
    <BaseLoader v-if="loading" />

    <QuizGameOver v-else-if="!current" />

    <div v-else class="quiz fill-height d-flex flex-column justify-space-between">
      <QuizContext
        v-if="showContext && current && !hideScenario"
        :question="current"
        @next="showContext = false"
      />

      <div v-if="!showContext">
        <QuizHome
         v-if="current.place === 'home'"
         :current="current"
        />
        <QuizFriends
         v-else-if="current.place === 'friends'"
         :current="current"
        />
        <QuizSchool
         v-else-if="current.place === 'school'"
         :current="current"
        />
        <QuizTwitter
         v-else-if="current.place === 'twitter'"
         :current="current"
        />
      </div>

      <QuizPlatter
        v-if="!showContext"
        class="mt-2"
        v-model="selected"
        :question="current"
        :showAnswer="showAnswer"
        @select="select"
        @next="next"
      />
    </div>
  </GameLayout>
</template>

<style scoped>
.quiz {
  max-width: 500px;
}

.chat-pattern {
  background: url('../assets/img/scenarios/chat-pattern.png');
}

.pattern {
  background: url('../assets/img/scenarios/pattern.png');
}

.v-application .rounded-pill {
  position: fixed;
}

.v-snack {
  margin-top: -48px !important;
}

>>> .v-main {
  padding: 0px 0px 0px !important;
}

@media screen and (max-width: 960px) {
  /* >>> .v-toolbar__content .v-btn {
    box-shadow: none !important;
  }

  >>> .theme--light.v-app-bar.v-toolbar {
      background-color: #fff !important;
  }

  >>> .v-toolbar__content {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
    padding: 8px;
  } */

  >>> .v-snack--top {
    margin-top: -56px !important;
  }
}

@media screen and (min-width: 960px) {
  >>> .v-main {
    padding: 0px 0px 0px !important;
  }
}

</style>

<script>
import GameLayout from '@/layouts/GameLayout.vue';
import QuizContext from '@/components/games/quiz/QuizContext.vue';
import QuizPlatter from '@/components/games/quiz/QuizPlatter.vue';
import QuizGameOver from '@/components/games/quiz/QuizGameOver.vue';
import QuizHome from '@/components/games/quiz/QuizHome.vue';
import QuizFriends from '@/components/games/quiz/QuizFriends.vue';
import QuizSchool from '@/components/games/quiz/QuizSchool.vue';
import QuizTwitter from '@/components/games/quiz/QuizTwitter.vue';

export default {
  name: 'Quiz',
  components: {
    GameLayout,
    QuizContext,
    QuizPlatter,
    QuizGameOver,
    QuizHome,
    QuizFriends,
    QuizSchool,
    QuizTwitter,
  },
  data: () => ({
    showContext: false,
    showAnswer: false,
    selected: -1,
  }),
  computed: {
    loading() {
      return this.$store.state.quiz.loading;
    },
    current() {
      return this.$store.getters['quiz/current'];
    },
    gameOver() {
      return !this.current && !this.loading;
    },
    isChat() {
      return this.current && this.current.place === 'twitter';
    },
  },
  methods: {
    prepareNewQuestion() {
      const q = this.current;
      if (!q) {
        return false;
      }
      this.showContext = !!this.$localized(q, 'context');
      this.hideScenario = false;

      return true;
    },
    select(i) {
      if (this.selected !== -1) {
        this.reset();
        return false;
      }

      const { correct } = this.current.answers[i];

      this.selected = i;
      this.showAnswer = !this.showAnswer;
      this.$store.dispatch('quiz/answer', {
        id: this.current.id,
        success: correct,
      });

      const correctText = this.$t('GAME.QUIZ.YOU_SUBTITLE_CORRECT');
      const wrongText = this.$t('GAME.QUIZ.YOU_SUBTITLE_NO');
      this.$store.dispatch('alerts/show', {
        text: correct ? correctText : wrongText,
        color: correct ? 'success' : 'error',
      });

      if (correct) {
        this.$track('game_success', 'quiz');
      } else {
        this.$track('game_error', 'quiz');
      }
      return true;
    },
    next() {
      this.reset();
      this.$store.dispatch('quiz/next');
      this.prepareNewQuestion();
    },
    reset() {
      this.hideScenario = true;
      this.selected = -1;
      this.showAnswer = !this.showAnswer;
    },
  },
  created() {
    // Only ask if no results
    this.$store.dispatch('quiz/get')
      .then(() => this.prepareNewQuestion());

    // On first play, show tutorial
    const showTutorial = !this.$store.state.settings.preEvaluatedQuiz;
    if (showTutorial) {
      this.$router.replace({ name: 'quizTutorial' });
    }
  },
};
</script>
